import { Button, Modal } from '@hakimo-ui/shared/ui-base';
import { ReactNode } from 'react';

interface Props {
  open: boolean;
  onCloseCb: () => void;
  content: ReactNode;
  title: string;
}

export function DetailsModal(props: Props) {
  const { content, onCloseCb, open, title } = props;
  const actions = <Button onClick={onCloseCb}>Close</Button>;
  return (
    <Modal open={open} onClose={onCloseCb} title={title} footer={actions}>
      <div className="p-8">{content}</div>
    </Modal>
  );
}
